import { FC } from 'react';
import { withLogo, InnerLogoProps } from '@tempusfinance/common-ui';

const NostraLogoComponent: FC<InnerLogoProps> = () => {
  return (
    <svg
      className="nostra__logo"
      xmlns="http://www.w3.org/2000/svg"
      width="165"
      height="29"
      viewBox="0 0 166 30"
      fill="none"
    >
      <path
        d="M0 17.3869L12.8091 10.2755L0 3.16402V17.3869ZM15.9984 12.0447L0 20.9292L15.9984 29.8099L31.9967 20.9292V3.16402L15.9984 12.0485V12.0447ZM15.7948 0.132156L8.45821 4.32304L15.9984 8.51009L23.5345 4.32304L15.7988 0.135994L15.7948 0.132156Z"
        fill="#FF4240"
      />
    </svg>
  );
};
export const NostraLogo = withLogo(NostraLogoComponent);
